<div class="lay-wrapper lay-wrapper--90">
  <app-welcome-banner [header]="'generic.main.hello' | translate" [title]="'generic.main.summaryReportsText'" />

  <app-summary-report-view
    (changeReportingPeriod)="changeReportingPeriod($event)"
    (sortBy)="sortBy($event)"
    (delete)="deleteItem($event)"
    (loadData)="loadData()" />
</div>
